import React from "react";
const FormPreview = ({ fields = [], onEditField = () => { } }) => {

    if (!fields.length) return <div className="text-muted">No fields added yet</div>;

    const handleClick = (e, fieldId) => {
        e.stopPropagation();
        onEditField(fieldId);
    };

    const computeWidthStyle = (w) => {
        if (w == null || w === "") return undefined;

        // numeric means percent (50 => "50%"), fractional (0.5) => "50%"
        if (typeof w === "number") {
            return { width: w > 1 ? `${w}%` : `${w * 100}%` };
        }

        // string - support presets like "half"/"full", raw percentages, px, "auto", etc.
        if (typeof w === "string") {
            const s = w.trim().toLowerCase();

            const presets = {
                full: "100%",
                half: "50%",
                third: "33.3333%",
                "two-thirds": "66.6667%",
                quarter: "25%",
                auto: "auto",
            };

            if (presets[s]) return { width: presets[s] };

            // bare number string -> treat as percent ("50" => "50%")
            if (/^\d+(\.\d+)?$/.test(s)) return { width: `${s}%` };

            // allow values like "50%", "200px", etc.
            return { width: s };
        }

        return undefined;
    };

    console.log("Rendering FormPreview with fields:", fields);

    return (
        <form className="">
            <div className="row form-preview-container">
                {fields.map((f) => {
                    const widthStyle = computeWidthStyle(f.width);
                    return (

                        <div key={f.id} className="mb-3 form-border-box" data-field-id={f.id} style={widthStyle}>
                            <div
                                key={f.id}
                                className="mb-3"
                                data-field-id={f.id}

                                onClick={(e) => handleClick(e, f.id)}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleClick(e, f.id); } }}
                            >

                                {f.type === "singleline" ? (
                                    <hr className="my-2" style={{ border: '1px solid #dee2e6' }} />
                                ) : (
                                    <>
                                        {f.type !== "iagree" && <label className="form-label">{f.label || f.name || "Field"} <span className="text-danger">{f.required ? "*" : ""}</span></label>}

                                        {/* render basic input types — attach onClick so clicking the control opens settings */}
                                        {["text", "email", "number", "password", "url", "tel", "whatsapp", "singleline"].includes(f.type) && (
                                            <>
                                                <input
                                                    className="form-control"
                                                    type={f.type === "whatsapp" ? "tel" : f.type === "singleline" ? "text" : f.type}
                                                    placeholder={f.placeholder || ""}
                                                    readOnly
                                                    onClick={(e) => handleClick(e, f.id)}

                                                />
                                                <small className="mt-1">{f.helperText}</small>
                                            </>
                                        )}

                                        {/* Date input */}
                                        {f.type === "date" && (
                                            <>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    readOnly
                                                    onClick={(e) => handleClick(e, f.id)}

                                                />
                                                <small className="mt-1">{f.helperText}</small>
                                            </>

                                        )}

                                        {/* Time input */}
                                        {f.type === "time" && (
                                            <>
                                                <input
                                                    className="form-control"
                                                    type="time"
                                                    readOnly
                                                    onClick={(e) => handleClick(e, f.id)}

                                                />
                                                <small className="mt-1">{f.helperText}</small>
                                            </>
                                        )}

                                        {/* OTP Verification Number */}
                                        {f.type === "numberwithotp" && (
                                            <>
                                                <div className="d-flex g-2">
                                                    <input
                                                        type="tel"
                                                        onClick={(e) => handleClick(e, f.id)}
                                                        className="form-control"
                                                        placeholder={f.placeholder || ""}
                                                        readOnly
                                                    />
                                                    <button
                                                        className="btn w-25 btn-outline-primary ml-2 btn-sm ms-2"
                                                        type="button"
                                                    >
                                                        Send OTP
                                                    </button>
                                                </div>
                                                <small className="mt-1">{f.helperText}</small>
                                            </>
                                        )}

                                        {/* i agree  */}
                                        {f.type === "iagree" && (
                                            <>
                                                <div className="form-check" onClick={(e) => handleClick(e, f.id)} style={widthStyle}>
                                                    <input className="form-check-input" type="checkbox" readOnly />
                                                    <label className="form-check-label">{f.label}</label>
                                                </div>
                                                <small className="mt-1">{f.helperText}</small>
                                            </>
                                        )}


                                        {/* Multiple Choice */}
                                        {f.type === "multiplechoice" && (
                                            <div>
                                                {(f.options || []).map((opt, i) => (
                                                    <div className="form-check" key={i}>
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            readOnly
                                                            onClick={(e) => handleClick(e, f.id)}
                                                        />
                                                        <label className="form-check-label">{opt.label ?? opt}</label>
                                                    </div>
                                                ))}
                                                <small className="mt-1">{f.helperText}</small>

                                            </div>
                                        )}

                                        {f.type === "textarea" && (
                                            <>
                                                <textarea
                                                    className="form-control"
                                                    placeholder={f.placeholder || ""}
                                                    readOnly
                                                    onClick={(e) => handleClick(e, f.id)}

                                                />
                                                <small className="mt-1">{f.helperText}</small>
                                            </>
                                        )}

                                        {f.type === "select" && (
                                            <>
                                                <select
                                                    className="form-select"
                                                    onClick={(e) => handleClick(e, f.id)}

                                                >
                                                    {(f.options || []).map((opt, i) => (
                                                        <option key={i} value={opt.value ?? opt}>
                                                            {opt.label ?? opt}
                                                        </option>
                                                    ))}
                                                </select>
                                                <small className="mt-1">{f.helperText}</small>
                                            </>
                                        )}

                                        {f.type === "checkbox" && (
                                            <>
                                                <div className="form-check" onClick={(e) => handleClick(e, f.id)} style={widthStyle}>
                                                    <input className="form-check-input" type="checkbox" readOnly />
                                                    <label className="form-check-label">{f.label}</label>
                                                </div>
                                                <small className="mt-1">{f.helperText}</small>
                                            </>
                                        )}

                                        {f.type === "radio" && (f.options || []).map((opt, i) => (
                                            <>
                                                <div className="form-check" key={i} onClick={(e) => handleClick(e, f.id)} style={widthStyle}>
                                                    <input className="form-check-input" type="radio" name={f.id} readOnly />
                                                    <label className="form-check-label">{opt.label ?? opt}</label>
                                                </div>
                                                <small className="mt-1">{f.helperText}</small>
                                            </>
                                        ))}


                                        {/* {!["text", "email", "number", "password", "textarea", "select", "checkbox", "radio"].includes(f.type) && (
                                            <div className="p-2 border rounded" onClick={(e) => handleClick(e, f.id)} style={widthStyle}>
                                                Click to edit
                                            </div>
                                        )} */}

                                    </>

                                )}

                            </div>

                        </div>
                    );
                })}
            </div>
        </form>
    );
};

export default FormPreview;